import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AlertService } from '@app/shared/services/alert/alert.service';
import { Observable } from 'rxjs';
import { WMSCustomer } from '@app/shared/models';
import { catchError } from 'rxjs/operators';
import { BaseService } from '../base.service';

@Injectable({ providedIn: 'root' })
export class WmsService extends BaseService {
    constructor(public http: HttpClient, alertService: AlertService) {
        super(alertService, http);
    }

    getCustomers(): Observable<WMSCustomer[]> {
        return this.http
            .get<WMSCustomer[]>(`${this.api}/wms/customers`)
            .pipe(catchError(this.handleError<WMSCustomer[]>(`all`, [])));
    }

    customerWebhooks(payload: any): Observable<any> {
        return this.http
            .post<any>(`${this.api}/wms/customer/webhooks`, payload)
            .pipe(catchError(this.handleError<any>(`customerWebhooks`)));
    }
}
